module.exports = __webpack_public_path__ + "img/LogoIG.bca7aa62.png";